
<template>
  <div class="container">
    <div class="content" v-show="shouldShowInvitation()">
      <img class="logo" src="/img/logo.png" />
      <img class="mainVisual" :src="mainVisualImageURL" />
      <p class="text">
        {{ nickname }}<br/>
        {{ $t("invitation_receipt__body_text") }}
      </p>
      <a class = "invitationReceipt" :href="adjustTrackerURL">{{ $t("invitation_receipt__button") }}</a>
    </div>
    <loading
      v-show="shouldShowLoading()"
      class="loading"
    ></loading>
    <not-found v-show="shouldShow404()" class="notfound"></not-found>
  </div>
</template>

<script>
import APIRequest from '@/utils/APIRequest'
import Loading from '@/components/Loading.vue'
import NotFound from '@/components/Error/NotFound.vue'
import { generateTrackerURL } from '@/utils/adjust_redirector'

export default {
  name: 'invitation',
  components: {
    Loading,
    NotFound,
  },
  data: function () {
    return {
      nickname: '',
      loading: true,
      setting: false,
      adjustTrackerURL: generateTrackerURL('zngu1v_fmj2dra', `/profile/${this.$route.params.profileId}`),
      mainVisualImageURL: `${this.$config.appImageBaseUrl}/invitations/invitation_request.png`
    }
  },
  created() {
  },
  async mounted() {
    this.profileId = this.$route.params.profileId
    const response = await this.fetchProfile()
    if (response.streamer) {
      this.nickname = response.streamer.nickname
      this.setting = this.iconUrl != '' && this.nickname != ''
    }
    this.loading = false
  },
  methods: {
    fetchProfile: async function () {
      const response = await this.$loader.post(
        new APIRequest(
          this.$config.appGatewayServerUrl,
          '/streamer/get_from_profile_id',
          {
            profileId: this.profileId,
          }
        )
      )
      return response
    },
    shouldShowLoading() {
      return this.loading
    },
    shouldShowInvitation() {
      return !this.loading && this.setting
    },
    shouldShow404() {
      return !this.loading && !this.setting
    }
  },
}
</script>

<style scoped>
.container {
  margin-left: auto;
  margin-right: auto;
  padding-top: 40px;
}

.content {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  gap: 24px;
}

.content  {
  max-width: 768px;
  margin: auto;
}

.container .mainVisual {
  width: 100%;
  margin: auto;
}

.container .logo {
  width: 210px;
  margin: auto;
}

.container a {
  color: #FFFFFF;
}

.container a:hover {
  color: #FFFFFF;
}

.content .text {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 42px;

  text-align: center;
  letter-spacing: 0.15px;
  color: #262626;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

.container .invitationReceipt {
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.25px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  gap: 10px;

  width: 70%;
  min-width: 270px;
  height: 44px;

  background: #262626;
  border-radius: 22px;

  flex: none;
  order: 3;
  flex-grow: 0;

  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;

}

.loading {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.notfound {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}
</style>
